import PermissionUtils from '../utilities/PermissisonUtils';
import { createContext, useContext } from 'react';
import { UserContext } from '../../App';

const useHasPermission = () => {
    
  // ===== DATA MANAGEMENT PERMISSIONS =====
 
  const { userDetails } = useContext(UserContext); 

  const hasDMPeriodicViewPermission = () => {
    return PermissionUtils.hasDMPeriodicViewPermission(userDetails?.roles);
  };

  const hasDMPeriodicUpdatePermission = () => {
    return PermissionUtils.hasDMPeriodicUpdatePermission(userDetails?.roles);
  };

  const hasDMOneTimeViewPermission = () => {
    return PermissionUtils.hasDMOneTimeViewPermission(userDetails?.roles);
  };

  const hasDMOneTimeUpdatePermission = () => {
    return PermissionUtils.hasDMOneTimeUpdatePermission(userDetails?.roles);
  };

  // ===== For Reporting studio =====
  // const hasReportingStudioViewPermission = () => {
  //   return PermissionUtils.hasReportingStudioViewPermission(userDetails?.roles);
  // }
  // const hasReportingStudioUpdatePermission = () => {
  //   return PermissionUtils.hasReportingStudioUpdatePermission(userDetails?.roles);
  // }

  // ===== For Reporting studio =====
    //GRI
    const hasGRIViewPermission = () => {
      return PermissionUtils.hasGRIViewPermission(userDetails?.roles);
    }
    const hasGRIUpdatePermission = () => {
      return PermissionUtils.hasGRIUpdatePermission(userDetails?.roles);
    }
    //BRSR
    const hasBRSRViewPermission = () => {
      return PermissionUtils.hasBRSRViewPermission(userDetails?.roles);
    }
    const hasBRSRUpdatePermission = () => {
      return PermissionUtils.hasBRSRUpdatePermission(userDetails?.roles);
    }
    //GHG
    const hasGHGReportViewPermission = () => {
      return PermissionUtils.hasGHGReportViewPermission(userDetails?.roles);
    }
    const hasGHGReportUpdatePermission = () => {
      return PermissionUtils.hasGHGReportUpdatePermission(userDetails?.roles);
    }

    //CSR
    const hasCSRViewPermission = () => {
      return PermissionUtils.hasCSRViewPermission(userDetails?.roles);
    }
    const hasCSRUpdatePermission = () => {
      return PermissionUtils.hasCSRUpdatePermission(userDetails?.roles);
    }
    //VSME
    const hasVSMEViewPermission = () => {
      return PermissionUtils.hasVSMEViewPermission(userDetails?.roles);
    }
    const hasVSMEUpdatePermission = () => {
      return PermissionUtils.hasVSMEUpdatePermission(userDetails?.roles);
    }
    //UAE-FDL
    const hasUAEFDLReportViewPermission = () => {
      return PermissionUtils.hasUAEFDLReportViewPermission(userDetails?.roles);
    }
    const hasUAEFDLReportUpdatePermission = () => {
      return PermissionUtils.hasUAEFDLReportUpdatePermission(userDetails?.roles);
    }

  // ===== For Goals and KPIs =====
  const hasGoalsAndKPIsViewPermission = () => {
    return PermissionUtils.hasGoalsAndKPIsViewPermission(userDetails?.roles);
  }
  const hasGoalsAndKPIsUpdatePermission = () => {
    return PermissionUtils.hasGoalsAndKPIsUpdatePermission(userDetails?.roles);
  } 

  // ===== For Double Materiality =====
  const hasDoubleMaterialityViewPermission = () => {
    return PermissionUtils.hasDoubleMaterialityViewPermission(userDetails?.roles);
  }
  const hasDoubleMaterialityUpdatePermission = () => {
    return PermissionUtils.hasDoubleMaterialityUpdatePermission(userDetails?.roles);
  }

  // ===== For GHG emissions =====
  const hasGHGEmissionsViewPermission = () => {
    return PermissionUtils.hasGHGViewPermission(userDetails?.roles);
  }
  const hasGHGEmissionsUpdatePermission = () => {
    return PermissionUtils.hasGHGUpdatePermission(userDetails?.roles);
  }

  // ===== For Home =====
  const hasHomeViewPermission = () => {
    return PermissionUtils.hasHomeViewPermission(userDetails?.roles);
  }

  // ===== For Dashboard =====
  const hasDashboardViewPermission = () => {
    return PermissionUtils.hasDashboardViewPermission(userDetails?.roles);
  }

  const hasDashboardUpdatePermission = () => {
    return PermissionUtils.hasDashboardUpdatePermission(userDetails?.roles);
  }
 
  // ===== For Data Collection =====
  const hasDataCollectionViewPermission = () => {
    return PermissionUtils.hasDataCollectionViewPermission(userDetails?.roles);
  }
  const hasDataCollectionUpdatePermission = () => {
    return PermissionUtils.hasDataCollectionUpdatePermission(userDetails?.roles);
  }

  //=== For Configuration ====

  const hasConfigViewPermission =() =>{
    return PermissionUtils.hasConfigViewPermission(userDetails?.roles)
  }
  const hasConfigUpdatePermission=()=>{
    return PermissionUtils.hasConfigUpdatePermission(userDetails?.roles)
  }

  //==For user management ====
  const hasUserViewPermission = () => {
    return PermissionUtils.hasUserViewPermission(userDetails?.roles); 
  }

  const hasUserUpdatePermission = () => {
    return PermissionUtils.hasUserUpdatePermission(userDetails?.roles); 
  }

  //=== For User inside Settings ====
  const hasSettingsViewPermission = () => {
    return PermissionUtils.hasSettingsViewPermission(userDetails?.roles);
  } 

  const hasSettingsUpdatePermission = () => {
    return PermissionUtils.hasSettingsUpdatePermission(userDetails?.roles);   
  }

  //for chat with data
  const hasChatWithDataViewPermission = () => {
    return PermissionUtils.hasChatWithDataViewPermission(userDetails?.roles);
  }

  // Super admin
  const isSuperAdmin = () => {
    return PermissionUtils.isSuperAdmin(userDetails?.roles);
  }
  
  // Previleged group permisions
  const belongsToPrevilegedGroup = () => {
    return PermissionUtils.belongsToPrevilegedGroup(userDetails?.roles);
  }

  const hasDCERevokePermission = () => {
    return PermissionUtils.hasDCERevokePermission(userDetails?.roles);
  }

  return {
    hasDMPeriodicViewPermission,
    hasDMPeriodicUpdatePermission,
    hasDMOneTimeViewPermission,
    hasDMOneTimeUpdatePermission,
    hasGoalsAndKPIsViewPermission,
    hasGoalsAndKPIsUpdatePermission,
    hasDoubleMaterialityViewPermission,
    hasDoubleMaterialityUpdatePermission,
    hasGHGEmissionsViewPermission,
    hasGHGEmissionsUpdatePermission,
    hasHomeViewPermission,
    hasDashboardViewPermission,
    hasDataCollectionViewPermission,
    hasDataCollectionUpdatePermission,
    hasConfigViewPermission,
    hasConfigUpdatePermission,
    hasUserViewPermission,
    hasUserUpdatePermission,
    hasSettingsViewPermission,
    hasSettingsUpdatePermission,
    hasChatWithDataViewPermission,
    hasDashboardUpdatePermission,
    hasGRIViewPermission,
    hasGRIUpdatePermission,
    hasBRSRViewPermission,
    hasBRSRUpdatePermission,
    hasCSRViewPermission,
    hasCSRUpdatePermission,
    hasVSMEViewPermission,
    hasVSMEUpdatePermission,
    hasGHGReportViewPermission,
    hasGHGReportUpdatePermission,
    hasUAEFDLReportViewPermission,
    hasUAEFDLReportUpdatePermission,
    isSuperAdmin,
    belongsToPrevilegedGroup,
    hasDCERevokePermission
  };
};

export default useHasPermission;
